<template>
	<div class="main-errors">
		<transition-group name="slide">
			<MainError
				v-for="error in mainErrors"
				:error="error"
				:key="error.id"
				@remove="removeMainError"
			/>
		</transition-group>
	</div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

import MainError from './MainError'

export default {
	name: 'MainErrors',

	components: {
		MainError
	},

	computed: {
		...mapState('ui', ['mainErrors'])
	},

	methods: {
		...mapMutations('ui', ['removeMainError'])
	}
}
</script>

<style scoped>
.main-errors {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 9999;
}

.slide-enter-active,
.slide-leave-active {
	transform: translate3d(0, -100%, 0);
	transition: transform 0.3s ease-in;
}

.slide-enter-to {
	transform: translate3d(0, 0, 0);
}
</style>
